(function($, Drupal) {
  'use strict';

  Drupal.behaviors.landing_page_field_updates = {
    attach: function(context, settings) {
      // Check to see if we are on the landing page.
      if ($('.node-landing_page').length) {
        // Move the .notice element inside of the .field--name-field-associated-form element.
        $('.layout-hero .field--name-field-associated-form').append($('.layout-hero .notice'));

        // Move the .arrow element inside of the .field--name-field-tagline element.
        $('.layout-hero .field--name-field-tagline').append($('.title-block > .arrow'));

        // Check if the layout-form__container class has the data attribute, if it does, apply the data to the submit button value.
        if ($('.layout-form__container').attr('data-submit')) {
          $('.layout-form__container button[type="submit"] span').html($('.layout-form__container').attr('data-submit'));
        }

        // Check if the layout-form__container's data-buttons attr contains social-work, if it does, check the value of the .form-item-degree-interest-social-work input.
        if ($('.layout-form__container').attr('data-buttons').indexOf('social-work') !== -1) {
          $('.layout-form__container .form-item-degree-interest-social-work input').prop('checked', true);
        }

        // Check if the layout-form__container's data-buttons attr social-sector-leadership, if it does, check the value of the .form-item-degree-interest-social-work input.
        if ($('.layout-form__container').attr('data-buttons').indexOf('social-sector-leadership') !== -1) {
          $('.layout-form__container .form-item-degree-interest-social-sector-leadership input').prop('checked', true);
        }

        // Check if the layout-form__container's data-buttons attr contains advanced_standing_social_work_program, if it does, check the value of the .form-item-degree-interest-social-work input.
        if ($('.layout-form__container').attr('data-buttons').indexOf('advanced_standing_social_work_program') !== -1) {
          console.log('advanced');
          $('.layout-form__container .form-item-degree-interest-advanced-standing-social-work input').prop('checked', true);
        }

        // Check if the layout-form__container's data-buttons attr contains full_time_social_work_program, if it does, check the value of the .form-item-degree-interest-social-work input.
        if ($('.layout-form__container').attr('data-buttons').indexOf('full_time_social_work_program') !== -1) {
          console.log('full time');
          $('.layout-form__container .form-item-degree-interest-full-time-social-work input').prop('checked', true);
        }

        // Check if the layout-form__container's data-buttons attr contains part_time_social_work_program, if it does, check the value of the .form-item-degree-interest-social-work input.
        if ($('.layout-form__container').attr('data-buttons').indexOf('part_time_social_work_program') !== -1) {
          console.log('part time');
          $('.layout-form__container .form-item-degree-interest-part-time-social-work input').prop('checked', true);
        }

        // Add --data-height custom property with a value equal to the height of the layout-form - 100 pixels
        $('.layout-body').css('--data-height', ($('.layout-form__container').height() - 240 + 'px'));
      }
    }
  };
})(jQuery, Drupal);
